<!-- 直播组件 子 小卡片-->
<template>
  <el-col :span="6">
    <div class="live-course">
      <div class="box" @click="gotoVideoCourse(live.course_id)">
        <img :src="live.course.course_cover" class="image">
        <div class="box_content">
          <button>立即报名</button>
        </div>
      </div>
      <div class="class_card_info" @click="gotoVideoCourse(live.course_id)">
        <div class="course_title">{{ live.course_title }}</div>
        <div class="tag">{{ live.course_desc }}</div>
        <div class="oneline">
          <div>
            <b>{{ live.course_time_desc.split(" ")[0] }}</b>
            {{ live.course_time_desc.split(" ")[1] }}
          </div>
          <div style="margin-left: auto">
            <b>{{ live.course.subscribe_num }}</b>
            人报名
          </div>
        </div>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: "class-live",
  props: ['live'],
  methods: {
    gotoVideoCourse(course_id) {
      this.$router.push({path: "/video/course_id/" + course_id})
    }
  }
}
</script>

<style scoped>
@import "../../common/style/classsection.css";

.live-course .bought:after {
  content: "";
  display: block;
  position: absolute;
  width: 60px;
  height: 60px;
  right: 11px;
  bottom: -7px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  background-image: url(./images/booked.png);
}

.flyello {
  float: right;
  font-size: 12px;
  font-weight: bold;
  color: #e37d28;
  margin-top: 3px;
}

.flmd {
  float: right;
  color: #999;
  font-size: 12px;
  margin-top: 3px;
}

.course_title {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-size: 15px;
  color: #333333;
  margin-top: 15px;
  font-weight: 444;
  width: 277px;
}
</style>



// WEBPACK FOOTER //
// src/components/Content/ClassCardLive.vue